import React from "react";

import { ErrorDetail } from "../../../components/ErrorDetail/ErrorDetail";

export const Error404: React.FC = () => {
  return (
    <>
      <ErrorDetail variant="error404" />
    </>
  );
};
